import React from 'react'
export const ContractContext = React.createContext()

